import {Size} from '@jetbrains/ring-ui/components/input/input'
import Select from '@jetbrains/ring-ui/components/select/select'
import type {ReactNode} from 'react'
import React, {useContext} from 'react'

import Markdown, {LinkOpenPolicy} from '../../../../../../../../../../common/Markdown/Markdown'
import {DisabledContext} from '../../../../../../../../contexts/DisabledContext'
import Details from '../../../../../../Details/Details'
import type {HotProperty, Option} from '../JobStepHotFields/JobStepHotFields.descriptors'

import styles from './JobStepEnumProperty.css'

type Props = {
  name: string
  label?: string
  value: string
  stepIndex: number
  onChange: (stepIndex: number, name: string, value: string | null) => void
  updated?: boolean
  description?: string | null
  options?: Option[]
  children: (params?: HotProperty[]) => ReactNode
}

export function JobStepEnumProperty({
  stepIndex,
  onChange,
  value,
  name,
  label,
  description,
  options,
  children,
}: Props) {
  const isDisabled = useContext(DisabledContext)
  const selected = options?.find(item => (value != null ? item.key === value : item.isDefault))

  return (
    <>
      <div className={styles.container}>
        <Select
          size={Size.FULL}
          data={options}
          selected={selected}
          selectedLabel={
            <>
              {label}
              {description && (
                <Details>
                  <Markdown
                    className={styles.description}
                    linkOpenPolicy={LinkOpenPolicy.ALL_IN_NEW_TAB}
                  >
                    {description}
                  </Markdown>
                </Details>
              )}
            </>
          }
          disabled={isDisabled}
          onSelect={item =>
            onChange(stepIndex, name, item == null || item.isDefault ? null : item.key)
          }
        />
      </div>
      {children(selected?.childParams)}
    </>
  )
}
